import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const CasesArchivedClient = React.lazy(
  () => import("../screean/case/casesArchivedClient")
);
export function casoArchivadoCliente() {
  return (
    <Route
      path="/casos-archivados-cliente"
      element={
        <ProtectedRoute>
          <ProtectedRoleAccountManager>
            <LazySuspense>
              <CasesArchivedClient />
            </LazySuspense>
          </ProtectedRoleAccountManager>
        </ProtectedRoute>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
